import { useEffect, useSyncExternalStore } from "react";
import { api } from "./api";

let deck = null;
let loadPromise = null;
let version = 0;
const listeners = new Set();

const notify = () => {
  version++;
  listeners.forEach((cb) => cb());
};
const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const cardKey = (card) =>
  `${(card.name || "").toLowerCase()}|${(card.set_name || "").toLowerCase()}|${card.card_number || ""}`;
const itemKey = (i) =>
  `${i.name_lower || (i.name || "").toLowerCase()}|${i.set_name_lower || (i.set_name || "").toLowerCase()}|${i.card_number || ""}`;

function loadDeck() {
  if (deck) return Promise.resolve(deck);
  if (!loadPromise) {
    loadPromise = api
      .get("/chase")
      .then((r) => {
        deck = r.data || [];
        notify();
        return deck;
      })
      .catch(() => {
        loadPromise = null;
        return [];
      });
  }
  return loadPromise;
}

export function useChaseState(card, enabled) {
  useSyncExternalStore(subscribe, () => version);
  useEffect(() => {
    if (enabled) loadDeck();
  }, [enabled]);
  if (!card || !deck) return false;
  const key = cardKey(card);
  return deck.some((i) => itemKey(i) === key);
}

export function useChaseDeckList() {
  useSyncExternalStore(subscribe, () => version);
  useEffect(() => {
    loadDeck();
  }, []);
  return deck;
}

export async function removeChase(id) {
  try {
    await api.delete(`/chase/${id}`);
  } catch (e) {
    if (e.response?.status !== 404) return false;
  }
  deck = (deck || []).filter((i) => i.id !== id);
  notify();
  return true;
}

export async function toggleChase(card) {
  await loadDeck().catch(() => {});
  const key = cardKey(card);
  const existing = (deck || []).find((i) => itemKey(i) === key);
  if (existing) {
    try {
      await api.delete(`/chase/${existing.id}`);
    } catch (e) {
      if (e.response?.status === 401) return "auth";
      if (e.response?.status !== 404) return "error";
    }
    deck = deck.filter((i) => i.id !== existing.id);
    notify();
    return "removed";
  }
  try {
    const { data } = await api.post("/chase", {
      name: card.name,
      set_name: card.set_name,
      card_number: card.card_number,
      game_type: card.game_type,
      image_url: card.reference_image_url || card.captured_image_url || null,
      source_card_id: card.id,
    });
    deck = [data, ...(deck || [])];
    notify();
    return "added";
  } catch (e) {
    if (e.response?.status === 401) return "auth";
    if (e.response?.status === 409) {
      deck = null;
      loadPromise = null;
      loadDeck();
      return "duplicate";
    }
    return "error";
  }
}
